import { update } from './enquiryApi';
import { checkResponseError, handleError } from './errorHandling';
import showResult from './showResult';

/**
 * @name loadResults
 * @description Načtení výsledků ankety.
 *
 * @param {String} enquiryId Identifikátor ankety.
 * @param {String} questionId Identifikátor anketní otázky.
 * @param {NodeListOf<HTMLElement>} answers Pole HTML elementů s odpovědmi.
 * @param {HTMLElement} voteNotice Slouží ke zobrazení hlášek uživateli.
 * @param {String} [selectedAnswerId=''] Identifikátor vybrané odpovědi. Slouží ke zvýraznění. Pokud není uveden, nezvýrazní se žádná odpověď.
 * @returns {Promise<void>}
 */
const loadResults = async (enquiryId, questionId, answers, voteNotice, selectedAnswerId) => {
  try {
    const response = await fetch(update(enquiryId));
    checkResponseError(response.status);
    const jsonDataUpdate = await response.json();
    const questionUpdatedData = jsonDataUpdate[enquiryId][questionId];

    answers.forEach((answer) => {
      const percent = `${Math.round(questionUpdatedData[answer.dataset.answerId].qperc_val)}%`;

      showResult(answer, percent, selectedAnswerId);
    });
  } catch (err) {
    handleError(err.message, voteNotice);
  }
};

export default loadResults;
